import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { Case } from '../../../../../../../../_base-shared/models/Case/Case';
import { CaseDepartmentAssignment} from '../../../../../../../../_base-shared/models/Department/CaseDepartmentAssignment';
import { DepartmentCategory } from '../../../../../../../../_base-shared/models/Department/DepartmentCategory';
import { User } from '../../../../../../../../_base-shared/models/User/User';
import { MainGlobalEventService } from '../../../../../_shared/services/main-global-event.service';
import { DepartmentService } from '../../../../department/department.service';

@Component({
  selector:    'app-case-department-user-editor',
  templateUrl: './case-department-user-editor.component.html',
  styles:      [],
})
export class CaseDepartmentUserEditorComponent implements OnInit {
  @Input() public case: Case;
  @Output() caseDepartmentsUpdated: EventEmitter<Array<CaseDepartmentAssignment>> = new EventEmitter<Array<CaseDepartmentAssignment>>();

  public form: UntypedFormGroup;
  public formActive: boolean;
  public isEditing = false;
  public isLoading = 0;
  public isSubmitting: boolean;
  public departmentCategories: Array<DepartmentCategory>;
  public caseDepartmentAssignments: Array<CaseDepartmentAssignment>;
  public authUser: User;

  constructor(private fb: UntypedFormBuilder,
              private toastr: ToastrService,
              private globalEventsService: MainGlobalEventService,
              private departmentService: DepartmentService) {
  }

  ngOnInit(): void {
    this.fetchCategorizedDepartments();
  }

  private buildForm(caseId, caseDepartmentAssignments: Array<CaseDepartmentAssignment>) {
    this.formActive = false;
    this.form       = this.fb.group({});

    this.globalEventsService.authUser$.subscribe(user => {
      this.authUser = user;
      this.departmentCategories.forEach(departmentCategory => {
        departmentCategory.departments.forEach(department => {
          const assignedUserId = caseDepartmentAssignments.filter(caseDepartmentAssignment => {
            return caseDepartmentAssignment.case_id === caseId &&
              caseDepartmentAssignment.department_id === department.id;
          }).map(caseAssignment => caseAssignment.user_id)[0];
          this.form.addControl(
            department.type,
            this.fb.control({value: assignedUserId, disabled: true}),
          );
        });
      });
      setTimeout(() => this.formActive = true, 0);
    });
    if (this.case.original_packager_id !== this.case.packager_id) {
      this.form.get('legal-advisor').disable({onlySelf: true});
    }
  }

  public toggleEditMode(state: boolean) {
    this.isEditing = state;
    this.isEditing ? this.form.enable() : this.form.disable();
    if (this.case.original_packager_id !== this.case.packager_id) {
      this.form.get('legal-advisor').disable({onlySelf: true});
    }
  }

  public submitForm(form: UntypedFormGroup) {
    if (form.invalid) {
      this.toastr.error('Invalid Configuration Form');
      return;
    }
    this.isSubmitting = true;
    this.departmentService.updateCaseDepartmentAssignments(this.case.id, form.value)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe(result => {
        this.caseDepartmentAssignments = result.data;
        this.caseDepartmentsUpdated.emit(this.caseDepartmentAssignments);
        this.isEditing = false;
        this.buildForm(this.case.id, this.caseDepartmentAssignments);
      });
  }

  private fetchCategorizedDepartments() {
    this.isLoading++;
    this.departmentService.categoryIndex(['departments.users'])
      .pipe(finalize(() => this.isLoading--)).subscribe(result => {
      this.departmentCategories = result.data;
      this.fetchCaseDepartmentAssignments(this.case.id);
    });
  }

  private fetchCaseDepartmentAssignments(caseId: number) {
    this.isLoading++;
    this.departmentService.getCaseDepartmentAssignments(caseId).pipe(finalize(() => this.isLoading--))
      .subscribe(result => {
        this.caseDepartmentAssignments = result.data;
        this.buildForm(caseId, this.caseDepartmentAssignments);
      });
  }

}
